import type { LeadWithValuation } from '@/types'
import { LEAD_COLUMNS, leadToRow, exportFileName } from './common'

export async function exportExcel(leads: LeadWithValuation[]) {
  const XLSX = await import('xlsx')

  const headers = LEAD_COLUMNS.map(c => c.header)
  const rows = leads.map(leadToRow)

  const ws = XLSX.utils.aoa_to_sheet([headers, ...rows])
  ws['!cols'] = LEAD_COLUMNS.map(c => ({ wch: c.width }))

  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, ws, 'Lead')

  XLSX.writeFile(wb, exportFileName('leads', 'xlsx'))
}
